import { Component, OnInit, Input, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { FormsModule, FormControl } from '@angular/forms';
// ngrx store
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

// services
import { BookingDetailsService } from '../../../my-account/services/booking-details.service';
import { AddNoteService } from '../../services/add-note.service';
// models
import { AppState } from '../../../booking/models/app-state.interface';


interface NoteUserDetails {
  firstName: string;
  lastName: string;
  userRoles: string;
  text: string;
  date: string;
}
interface AddNoteRequest {
  bookingReference: string;
  bookingJourneyReference: string;
  userId: string;
  text: string;
  priority: string;
}

@Component({
  selector: 'app-booking-details-notes',
  templateUrl: './booking-details-notes.component.html',
  styleUrls: ['./booking-details-notes.component.scss'],
  providers: [AddNoteService]
})
export class BookingDetailsNotesComponent implements OnInit, OnChanges, OnDestroy {

  @Input()
  appCopy;

  @Input()
  selectedLanguage;
  
  @Input()
  bookingRef;

  @Input()
  user;

  @Input()
  viewState;

  @Input()
  adminBookingDetails;

  @Input()
  adminBookingDetailsLoaded;

  private _addNoteSubscription: Subscription;
  private _getNoteSubscription: Subscription;
  private _noteAdded = false;

  public bookingDetailsAdminNotes: Array<any>;
  public bookingDetailsAdminLoaded: Boolean = false;
  public noteUserArray: Array<any> = [];
  public addNote;
  public showAddNoteLoader: Boolean = false;
  public showAddNote: Boolean = false;
  public noBookingNotes: Boolean = false;
  public bookingNotes = null;

  constructor(
    private _bookingDetailsService: BookingDetailsService,
    private _addNoteService: AddNoteService
  ) { }

  ngOnInit() {

    // note text area element
    this.addNote = new FormControl('');

    this._addNoteSubscription = this._addNoteService.addNoteResponse$
      .subscribe(res => {
        if (res) {
          this.toggleAddNoteSection();
          this.bookingDetailsAdminLoaded = false;
          this.noteUserArray = [];
          this._bookingDetailsService.getUserBookingByReference(this.user.userToken, this.bookingRef);
        }
      });

    // subscribe to get latest added note
    this._getNoteSubscription = this._bookingDetailsService.bookingDetailsItem$
      .subscribe(res => {
        if (this._noteAdded) {
          this.bookingNotes = res.bookingDetails.bookingJourneyDetails[0].bookingNotes;
          this.createBookingNotes();
          this._noteAdded = false;
        }
      });

  }

  ngOnChanges(changes: SimpleChanges) {
    if (typeof changes.adminBookingDetailsLoaded !== 'undefined') {
      if (changes.adminBookingDetailsLoaded.currentValue && !this._noteAdded) {
        this.bookingNotes = this.adminBookingDetails.bookingJourneyDetails[0].bookingNotes;
        this.createBookingNotes();
      }
    }
  }

  createBookingNotes() {

    if (this.bookingNotes.length === 0) {
      this.noBookingNotes = true;
      this.bookingDetailsAdminLoaded = true;
      this.showAddNoteLoader = false;
      return;
    }

    this.noBookingNotes = false;

    let userItem: NoteUserDetails = {
      firstName: '',
      lastName: '',
      userRoles: '',
      date: '',
      text: ''
    };

    for (const item of this.bookingNotes) {

      const roleHolder = item.user.userRoles.map(i => { return i.description; }).join(', ');

      userItem = {
        firstName: item.user.firstName,
        lastName: item.user.lastName,
        userRoles: roleHolder,
        date: item.dateTimeCreatedUTC,
        text: item.text
      };

      this.noteUserArray.push(userItem);

    }

    this.bookingDetailsAdminLoaded = true;
    this.showAddNoteLoader = false;
  }

  handleNoteSubmit(value, event: Event) {

    event.preventDefault();

    if (value.addNote.trim() === '') {
      return;
    }

    this.showAddNoteLoader = true;
    this._noteAdded = true;

    const request: AddNoteRequest = {
      bookingReference: this.adminBookingDetails.bookingJourneyDetails[0].bookingReference,
      bookingJourneyReference: this.adminBookingDetails.bookingJourneyDetails[0].bookingJourneyReference,
      userId: this.user.currentUser.userId,
      text: value.addNote,
      priority: 'Medium'
    };

    this._addNoteService.addBookingNote(request, this.user.userToken);

  }

  toggleAddNoteSection() {
    this.showAddNote = !this.showAddNote;
  }

  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1))
    .subscribe(s => state = s);
    return state;
  }

  ngOnDestroy() {
    this._addNoteSubscription.unsubscribe();
    this._getNoteSubscription.unsubscribe();
  }

}
